import React, {
    PropTypes,
} from 'react';
import {Modal, Button} from 'react-bootstrap';

const Dialog = ({body, title, yesTitle, noTitle, yes, no, show}) => {
    return (
        <Modal onHide={no} show={show}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                {yesTitle ? <Button onClick={yes} bsStyle="success">{yesTitle}</Button> : ''}
                {noTitle ? <Button onClick={no}> {noTitle}</Button> : ''}
            </Modal.Footer>
        </Modal>
    );
};

Dialog.propTypes = {
    body: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
};

export default Dialog;



/** WEBPACK FOOTER **
 ** ./src/components/Dialog.js
 **/